/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiASkipBackIcon16Light } from './MediaUiASkipBackIcon16Light';
import { MediaUiASkipBackIcon16Regular } from './MediaUiASkipBackIcon16Regular';
import { MediaUiASkipBackIcon16Solid } from './MediaUiASkipBackIcon16Solid';
import { MediaUiASkipBackIcon20Light } from './MediaUiASkipBackIcon20Light';
import { MediaUiASkipBackIcon20Regular } from './MediaUiASkipBackIcon20Regular';
import { MediaUiASkipBackIcon20Solid } from './MediaUiASkipBackIcon20Solid';
import { MediaUiASkipBackIcon24Regular } from './MediaUiASkipBackIcon24Regular';
import { MediaUiASkipBackIcon24Solid } from './MediaUiASkipBackIcon24Solid';
import { MediaUiASkipBackIcon32Regular } from './MediaUiASkipBackIcon32Regular';
import { MediaUiASkipBackIcon64Regular } from './MediaUiASkipBackIcon64Regular';
var sizes = {
    16: {
        light: MediaUiASkipBackIcon16Light,
        regular: MediaUiASkipBackIcon16Regular,
        solid: MediaUiASkipBackIcon16Solid,
    },
    20: {
        light: MediaUiASkipBackIcon20Light,
        regular: MediaUiASkipBackIcon20Regular,
        solid: MediaUiASkipBackIcon20Solid,
    },
    24: {
        regular: MediaUiASkipBackIcon24Regular,
        solid: MediaUiASkipBackIcon24Solid,
    },
    32: {
        regular: MediaUiASkipBackIcon32Regular,
    },
    64: {
        regular: MediaUiASkipBackIcon64Regular,
    },
};
export var MediaUiASkipBackIcon = forwardRef('MediaUiASkipBackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
